import React from 'react';
import { Breadcrumbs } from '../components/ui/Breadcrumbs';
import { useLanguage } from '../i18n/LanguageContext';
interface PrivacyPolicyPageProps {
  onNavigate: (page: string) => void;
}
export function PrivacyPolicyPage({
  onNavigate
}: PrivacyPolicyPageProps) {
  const {
    t
  } = useLanguage();
  return <div className="min-h-screen bg-slate-50 pb-24" data-id="element-25249">
      <div className="bg-white border-b border-slate-200 pt-6 pb-12" data-id="element-25250">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-25251">
          <Breadcrumbs items={[{
          label: t('legal.backToHome'),
          onClick: () => onNavigate('home')
        }, {
          label: t('legal.privacy.title')
        }]} className="mb-8" data-id="element-25252" />
          <h1 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4" data-id="element-25253">
            {t('legal.privacy.title')}
          </h1>
          <p className="text-slate-500" data-id="element-25254">{t('legal.lastUpdated')}</p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-25255">
        <div className="bg-white rounded-2xl p-8 sm:p-12 border border-slate-200 shadow-sm prose prose-slate max-w-none" data-id="element-25256">
          <h2 data-id="element-25257">{t('legal.privacy.s1.title')}</h2>
          <p data-id="element-25258">{t('legal.privacy.s1.p1')}</p>

          <h2 data-id="element-25259">{t('legal.privacy.s2.title')}</h2>
          <p data-id="element-25260">{t('legal.privacy.s2.p1')}</p>
          <ul data-id="element-25261">
            <li data-id="element-25262">{t('legal.privacy.s2.l1')}</li>
            <li data-id="element-25263">{t('legal.privacy.s2.l2')}</li>
            <li data-id="element-25264">{t('legal.privacy.s2.l3')}</li>
          </ul>

          <h2 data-id="element-25265">{t('legal.privacy.s3.title')}</h2>
          <p data-id="element-25266">{t('legal.privacy.s3.p1')}</p>
          <ul data-id="element-25267">
            <li data-id="element-25268">{t('legal.privacy.s3.l1')}</li>
            <li data-id="element-25269">{t('legal.privacy.s3.l2')}</li>
            <li data-id="element-25270">{t('legal.privacy.s3.l3')}</li>
            <li data-id="element-25271">{t('legal.privacy.s3.l4')}</li>
          </ul>

          <h2 data-id="element-25272">{t('legal.privacy.s4.title')}</h2>
          <p data-id="element-25273">{t('legal.privacy.s4.p1')}</p>

          <h2 data-id="element-25274">{t('legal.privacy.s5.title')}</h2>
          <p data-id="element-25275">{t('legal.privacy.s5.p1')}</p>

          <h2 data-id="element-25276">{t('legal.privacy.s6.title')}</h2>
          <p data-id="element-25277">{t('legal.privacy.s6.p1')}</p>
          <ul data-id="element-25278">
            <li data-id="element-25279">{t('legal.privacy.s6.l1')}</li>
            <li data-id="element-25280">{t('legal.privacy.s6.l2')}</li>
            <li data-id="element-25281">{t('legal.privacy.s6.l3')}</li>
          </ul>

          <h2 data-id="element-25282">{t('legal.privacy.s7.title')}</h2>
          <p data-id="element-25283">{t('legal.privacy.s7.p1')}</p>
        </div>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm" data-id="element-25284">
          <button onClick={() => onNavigate('terms')} className="text-indigo-600 hover:text-indigo-800 font-medium transition-colors" data-id="element-25285">
            {t('legal.terms.title')} →
          </button>
          <button onClick={() => onNavigate('contact')} className="text-slate-500 hover:text-slate-700 font-medium transition-colors" data-id="element-25286">
            {t('legal.contactUs')}
          </button>
        </div>
      </div>
    </div>;
}